import { useEffect, useState } from "react";

export const useGetParamsUrl = <T>(search?: string): T | null => {
  const [value, setValue] = useState<T | null>(null);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const paramsObj: Record<string, string> = {};
    urlParams.forEach((value, key) => {
      paramsObj[key] = value;
    });

    setValue(paramsObj as T);
  }, [search]);

  return value;
};
